<template>
  <p v-if="visibleSpan" :role="warning ? 'alert' : 'none'" class="opc-zmone__desc" :class="{ 'is-warning': warning }" @click='handleClick($event)'>
    <span v-html="text"></span>
    <slot />
  </p>
</template>

<script>
import { mapGetters } from 'vuex'
import { getTitleNameI18nKey, isBizPlusContext, isAutoAddableAndAutoAddPlanSelected } from './common/utils';
import {
  unlockBizLicenseCount,
  maxBizAndBizPlusLicenseCount,
  INDUSTRIES,
  ZOOM_MEETING_EDUCATION_MIN_LICENSE,
  ZOOM_MEETING_EDUCATION_MAX_LICENSE,
} from '@/common/constants';
import { translateToEn } from '@/plugins/i18n'

export default {
  props: {
    type: String,
    number: Number,
    invisibleCategory: {
      type: Array,
      default: () => [],
    },
    additionalSpans: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    ...mapGetters(['healthcareAvailable', 'getSelectedPlans']),
    spans() {
      return {
        pro: [
          {
            value: 1,
            text: this.$t('billing.zone.min_of_pro'),
          },
          {
            value: 99,
            default: true,
            text: this.$t('billing.zone.max_of_pro_99'),
          },
        ],
        biz: [
          {
            value: unlockBizLicenseCount ? 1 : 10,
            text: isBizPlusContext ? (unlockBizLicenseCount ? '' : this.$t('billing.zone.biz_combined_bizplus')) : (unlockBizLicenseCount ? this.$t('billing.zone.min_of_biz_1') : this.$t('billing.zone.min_of_biz_new', { number: 10 })),
            default: true,
          },
          {
            value: maxBizAndBizPlusLicenseCount,
            text: this.$t('billing.zone.max_license_of_biz', [maxBizAndBizPlusLicenseCount, maxBizAndBizPlusLicenseCount+1]),
          },
        ],
        education: [
          {
            value: ZOOM_MEETING_EDUCATION_MIN_LICENSE,
            text: this.$t('billing.zone.min_of_licenses', [ZOOM_MEETING_EDUCATION_MIN_LICENSE]),
          },
          {
            value: ZOOM_MEETING_EDUCATION_MAX_LICENSE,
            default: true,
            text: this.$t('billing.zone.max_of_licenses', [ZOOM_MEETING_EDUCATION_MAX_LICENSE]),
          },
        ],
        zoneduschcmp: [
          {
            value: 20,
            default: true,
            text: this.$t('billing.zone.min_of_licenses', [20]),
          },
          {
            value: this.$context.is.edu2esc? 9999: 250,
            text: this.$t('billing.zone.max_of_license_contact_us', [250]),
          },
        ],
        zwb: [
          {
            value: 1,
            text: '',
          },
          {
            value: 99,
            text: this.$t('billing.zone.max_of_plans', [99, 100]),
          },
        ],
        proplus: [
          {
            value: 1,
            text: '',
          },
          {
            value: 99,
            text: this.$t('billing.zone.max_of_plans_user', [99, 100]),
          },
        ],
        ...this.additionalSpans
      }
    },
    visibleSpan() {
      if (this.invisibleCategory.includes(this.type)) {
        return null;
      }
      return this.spans[this.type]
    },
    warning() {
      // @jira https://zoomvideo.atlassian.net/browse/ZOOM-765304
      // auto add: switch back to Pro by exploring other plans, keep the warning banner
      if (this.type === 'biz' && isAutoAddableAndAutoAddPlanSelected()) {
        return this.number <= this.visibleSpan?.[0]?.value;
      }
      return this.number >= this.visibleSpan?.[1]?.value;
    },
    text() {
      if (this.number == this.visibleSpan?.[1].value) {
        return this.visibleSpan?.[1].text;
      }
      if (this.number == this.visibleSpan?.[0].value) {
        return this.visibleSpan?.[0].text;
      }
      return this.visibleSpan.find((x) => x.default)?.text;
    },
    isHealthcareHost() {
      return this.healthcareAvailable && this.type === 'pro'
    },
    isSchool() {
      return this.type === 'zoneduschcmp'
    }
  },

  created() {
    this.$watch(
      () => !!(this.visibleSpan?.length > 0 && this.warning),
      (warning) => {
        if (warning) {
          if (this.isHealthcareHost) {
            const trackingPlanName = translateToEn(getTitleNameI18nKey(this.type))
            this.$tracking.buyInteraction(
              'banner - product level',
              `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${translateToEn('billing.zone.max_of_pro_99')}`,
            )
          }

          if (this.isSchool) {
            this.$tracking.buyInteraction(
              'banner - product level',
              `${translateToEn(getTitleNameI18nKey(this.type))} - ${this.text?.replace(/(<([^>]+)>)/ig, '')} - impression`,
            )
          }
        }
      },
      { immediate: true },
    )
  },

  methods: {
    handleClick(e) {
      if (this.isSchool && e.target.tagName?.toUpperCase() === 'A') {
        this.$tracking.buyInteraction('banner - product level', `${translateToEn(getTitleNameI18nKey(this.type))} - ${e.currentTarget.textContent} -  ${e.target.textContent}`)
      }
      this.$emit('click', e);
    }
  }
};
</script>
